/**
 * usage
 * import { EventScroller } from './utilities/js/resize-handler';
 *
 * const eventScroller = new EventScroller();
 * eventScroller.init();
 *
 * eventScroller.customFunctions.push(() => { // do stuff });
 */

class EventScroller {
    constructor () {
        this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.customFunctions = [];
        window.scrollDirection = 'down';
        window.scrollPosition = this.lastScrollTop;
    }

    init () {
        this.bindEvents();
        this.detectProgrammaticScroll();
    }

    bindEvents () {
        let ticking = false;

        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    window.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

                    if (window.scrollPosition > this.lastScrollTop) {
                        window.scrollDirection = 'down';
                    } else {
                        window.scrollDirection = 'up';
                    }

                    this.lastScrollTop = window.scrollPosition <= 0 ? 0 : window.scrollPosition; // For Mobile or negative scrolling

                    ticking = false;

                    for (let i = 0; i < this.customFunctions.length; i++) {
                        const customFunction = this.customFunctions[i];

                        if (typeof customFunction === 'function') {
                            customFunction();
                        }
                    }
                });

                ticking = true;
            }
        }, { passive: true });
    }

    // helper function to check, if element is in view
    onScreen ($element, tolerance = 0, ignoreBefore = false) {
        const bounds = $element.getBoundingClientRect();

        if (ignoreBefore) {
            return (((bounds.top + tolerance) - window.innerHeight) <= 0 && bounds.bottom > 0);
        } else {
            if (bounds.top <= 0) {
                return true;
            } else {
                return (((bounds.top + tolerance) - window.innerHeight) <= 0 && bounds.bottom > 0);
            }
        }
    }

    detectProgrammaticScroll() {
        const setUserScrolling = () => {
            this.userIsScrolling = true;

            clearTimeout(this.scrollTimeout);
            this.scrollTimeout = setTimeout(() => {
                this.userIsScrolling = false;
            }, 1000);
        };

        ['wheel', 'touchstart', 'keydown'].forEach(eventType => {
            window.addEventListener(eventType, setUserScrolling);
        });

        window.addEventListener('keydown', (event) => {
            if (event.key === 'Tab') {
                this.userIsScrolling = false; // Ensure it's considered programmatic
            }
        });

        window.addEventListener('scroll', () => {            
            if (!this.userIsScrolling) {
                const event = new CustomEvent('programmaticScrollDetected');
                window.dispatchEvent(event);
            }
        });
    }
}

export { EventScroller };
